import { get, post, put, Delete } from '../axios'

// 模型AI-列表 (分页)
export const modelAiList = params => get(`/web/modelAi/list`, params);

// 模型AI-列表（全部）
export const modelAiListAll = params => get(`/web/modelAi/listAll`, params);

// 模型AI-新增
export const modelAiAdd = params => post(`/web/modelAi/add`, params);

// 模型AI-更新
export const modelAiUpdate = params => put(`/web/modelAi/update`, params);

// 模型AI-删除（支持单个ID或逗号分隔的多个ID）
export const modelAiDelete = ids => Delete(`/web/modelAi/delete/${ids}`);
